import React from 'react';
const Partition = (props) => {
  const { text, className } = props;

  return (
    <div className={`d-flex align-items-center partitionContainer  gap-1 ${className} my-4 `}>
      <div className='w-50 mt-1'>
        <hr className='my-1' />
        <hr className='my-1' />
      </div>
      <div className='mt-1'>
        <p
          style={{ fontSize: '10px', fontFamily: 'Montserrat-Regular' }}
          className='partitionText text-center mb-0'
        >
          {text}
        </p>
      </div>
      <div className='w-50 mt-1'>
        <hr className='my-1' />
        <hr className='my-1' />
      </div>
    </div>
  );
};

export default Partition;
